import React from 'react';
import config from 'appconfig';
import { StyledLink, StyledSpan } from '../StyledComponents';
import { Dimensions } from 'components/visuals';
import { messages } from 'modules/mac/messages';
import { FormattedMessage } from 'react-intl';
import { ATLASSIAN_ORGANISATION } from 'data/products/keys';
import { StyledPipe } from '../ActionsSectionElements/StyledPipe';
import { DetailsRow } from './DetailsRow';

const PaymentDetailsSection = ({
  accountDetails: {
    creditCardData,
    latestPeriod,
    txAMigrated,
    entSubMigrated,
    productsBilledInCCP,
    externalUuid,
    id,
  },
  productKey,
}) => {
  const card = creditCardData;

  const shouldShowEditCard =
    card?.gateway !== 'BRAINTREE_PAYPAL' && new Date(latestPeriod.endDate) > new Date();

  const orgOrSiteValue = productKey !== ATLASSIAN_ORGANISATION ? 's' : 'o';

  const pageURLPart = card ? 'update-credit-card' : 'payment-details';
  const paymentDetailsLink =
    txAMigrated || entSubMigrated || productsBilledInCCP
      ? `${config.adminHubUrl}/${orgOrSiteValue}/${externalUuid}/billing/paymentdetails`
      : `${config.root}/my/${pageURLPart}/${id}`;

  return (
    <DetailsRow
      label={<FormattedMessage {...messages.paymentMethod} />}
      value={
        card ? (
          <>
            <StyledSpan data-cy="card-details" $padding={`0 ${Dimensions.units(0.5)}px 0 0`}>
              {`${card.type} - ${card.maskedNumber} (${card.expiryMonth}/${card.expiryYear}) - ${card.name}`}
            </StyledSpan>
            {shouldShowEditCard && (
              <>
                <StyledPipe />
                <StyledLink href={paymentDetailsLink}>
                  <FormattedMessage {...messages.editCreditCard} />
                </StyledLink>
              </>
            )}
          </>
        ) : (
          <StyledLink data-cy="add-payment-method-btn" href={paymentDetailsLink || ''}>
            <FormattedMessage {...messages.providePaymentDetails} />
          </StyledLink>
        )
      }
    />
  );
};

export default PaymentDetailsSection;
